import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import { ValidationResult, validateLabel } from '../../utils/validationUtils';

import MarkReviewFormStyles from '../mark/form/MarkReviewForm.module.scss';

interface FieldLabelProps {
  fieldLabels: string[];
  hasApiError?: boolean;
  initialLabel: string;
  onLabelChange: (newLabel: string) => void;
  originalLabel: string;
  readOnly?: boolean;
  setIsDuplicatedDisabled: (isDisabled: boolean) => void;
}

const FieldLabel: React.FC<FieldLabelProps> = ({
  fieldLabels,
  hasApiError = false,
  initialLabel,
  onLabelChange,
  originalLabel,
  readOnly = false,
  setIsDuplicatedDisabled, // used here for single field validation
}) => {
  const [label, setLabel] = useState(initialLabel);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  useEffect(() => {
    if (!readOnly) {
      const validationResult = validateLabel(label, fieldLabels);
      handleValidationResult(validationResult);
    } else {
      setError(false);
      setHelperText('');
      setIsDuplicatedDisabled(true);
    }
    // eslint-disable-next-line
  }, [label, fieldLabels, readOnly]);

  const handleValidationResult = (result: ValidationResult) => {
    if (!hasApiError) {
      setError(!result.isValid);
      setHelperText(result.errorMessage);
      setIsDuplicatedDisabled(!result.isValid);
    }
    if (result.isValid) {
      onLabelChange(label);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newLabel = e.target.value;
    setLabel(newLabel);
  };

  return (
    <TextField
      FormHelperTextProps={{
        className: `${MarkReviewFormStyles.warningText} ${MarkReviewFormStyles.helperText}`,
      }}
      InputProps={{ readOnly: readOnly }}
      className={MarkReviewFormStyles.textField}
      data-cy={`duplicate-field-label-${originalLabel}`}
      disabled={readOnly}
      error={hasApiError || error}
      fullWidth
      helperText={!hasApiError ? helperText : ''}
      margin="none"
      onChange={handleChange}
      value={label}
    />
  );
};

export default FieldLabel;
